import { useTranslation } from 'react-i18next'

export const MedicareCardBack = () => {
  const { t } = useTranslation('getMyMedicareCardPage')

  return (
    <div className="my-c-medicare-card-half">
      <div className="my-c-medicare-card my-c-medicare-card-back">
        <div className="content-padding">
          <p className="my-u-mb--10 my-u-color-label-desc" lang="en">

            You may be asked to show this card when you get health care
            services. Only give your personal Medicare information to health
            care providers, your insurers, or people you trust who work with
            Medicare on your behalf. <strong>WARNING:</strong> Intentionally
            misusing this card may be considered fraud and/or other violation of
            federal law and is punishable by law.
          </p>
          <p className="my-u-mb--10 my-u-color-label-desc" lang="es">
            Es posible que le pidan que muestre esta tarjeta cuando reciba
            servicios de cuidado médico. Solamente dé su información personal de
            Medicare a los proveedores de salud, sus aseguradores o personas de
            su confianza que trabajan con Medicare en su nombre.{' '}
            <strong>ADVERTENCIA!</strong> El mal uso intencional de esta tarjeta
            puede ser considerado como fraude y/u otra violación de la ley
            federal y es sancionada por la ley
          </p>
          <p className="my-u-mb--10 my-u-color-label-desc ds-u-text-align--center">
            <strong>1-800-MEDICARE</strong> (1-800-633-4227/TTY:
            1-877-486-2048);
          </p>
          <p className="my-u-mb--10 my-u-color-label-desc ds-u-text-align--center">
            <strong>Medicare.gov</strong>
          </p>
        </div>
      </div>
      <p className="my-c-medicare-card-title">
        {t('printCardPage.backOfCard')}
      </p>
    </div>
  )
}
